import http from '@/plugins/axios';

export async function submit_order(payload) {
    payload.table_id = payload.location_id;
    const response = await http.post(`customer/order`, payload);
    return response.data;

}
export async function check_coupon(payload) {
    const response = await http.post(`check-coupon`, payload);
    return response.data;
}

export async function calc_promotion(payload) {
    const response = await http.post(`promotion/calculate`, payload);
    return response.data.data;
}

export async function calc_delivery_fee(payload) {
    const response = await http.post(`delivery_fee/calculate`, payload);
    return response.data.data;
}
export async function get_order_detail(id) {
    const response = await http.get(`sale-detail/${id}`,);
    return response.data.item;
}


export async function get_order_list(payload) {
    // 0. Pending
    // 1. Acknowledged
    // 2. Preparing
    // 3. Delivering
    // 4. Done
    let { next_page, limit, status } = payload;
    let url = `customer/order-report?page=${next_page}&limit=${limit}`;
    url = url + `&status=${status}`
    const response = await http.get(url);
    return response.data;
}